import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from 'src/app/providers/alerts.service';
import { AuthService } from 'src/app/providers/auth.service';
import { UserService } from 'src/app/providers/user.service';
import { CommonService } from "src/app/providers/common.service";
import { apiLinks } from 'src/app/core/api-links/api-links';
@Component({
  selector: 'app-login-as-modal',
  templateUrl: './login-as-modal.component.html',
  styleUrls: ['./login-as-modal.component.scss']
})
export class LoginAsModalComponent implements OnInit {
  returnUrl: any;
  @Input() header: string;
  @Input() body: string;
  @Input() confirmButton: string;
  @Input() email: string;
  @Input() password: string;
  @Input() systemUser: string;
  @Input() systemEmail: string;
  @Input() isLoading: boolean = false
  @Input() isError: boolean = false
  @Input() loginUser = '';
  @Input() isEnableProxyEmail = true;

  isLoggin = false


  mfaTitle = "Multi-Factor Authentication (MFA)";
  mfaContent = "To keep your account safe from unauthorized account creation, we have sent a Security Code to your email and phone.";
  mfaData={};
  isMfaEnabled=false;
  apiName='';
  formData={}
  isFullWidth=true;
  
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private alertsService: AlertsService,
    public router: Router,
    private route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    public CommonService: CommonService,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
  }

  async loginAs() {
    this.isLoggin = true;
    localStorage.removeItem("logger_token");
    // const logOut = await this.authService.logoutService()
    // await logOut.toPromise();
    let data = {
      email: this.email,
      // password: this.password,
      isLoginAs: "true",
      sysUser: this.systemUser,
      sysEmail: this.systemEmail,
      subDomain:window.location.origin,
      ...((this.loginUser == 'Merchant') && { isEnableProxyEmail: this.isEnableProxyEmail ? "true" : "false"}),
    }

    this.validateUser(data,apiLinks.mfa.pxyLoginOTPVerify,apiLinks.validatePxyLogin);

  }

  async validateUser(formData,otpVerifyApiName,validateApiName){

    const data = {
      ...formData,
      fingerPrintData:this.CommonService.getMfaFingerPrint()
    }
    try{

      const res = await this.CommonService.postCommonHttpClient(validateApiName,data).toPromise();
      if(res?.mfa){
        this.isMfaEnabled = true;
        this.mfaData={...res}; //UCR - short note for user creation 
        this.apiName = otpVerifyApiName
        this.formData = {...formData,uiRefId: res?.uiRefId}
        
      }else{
        this.loadLoggeinUserDashBoard(res);
      }

    }catch(err){
        this.isLoggin = false
        console.log(err);
        this.alertsService.showAlert({
          alertType: "error",
          status: err.status,
          message: err.message,
        });
    }


  }

  afterSuccessVerifyOtp(res){
    console.log(res);
    this.loadLoggeinUserDashBoard(res);
  }

  onError(error){
    console.log(error);
  }

  loadLoggeinUserDashBoard(res){
    this.authService.setUser(res)
    localStorage.setItem("logger_token", "multiLogin");
    let defaultcolor = "theme-purple-light";
    let themeChColor = res.themeColor == null ? defaultcolor : res.themeColor;
    this.userService.userFavTheme.next(themeChColor);
    if (themeChColor) {
      this.document.body.classList.remove(
        "theme-cyan-light",
        "theme-bluegrey-light",
        "theme-purple-light"
      );
      this.document.body.classList.add(themeChColor);
    }
    const excludeFeatures = res && res.excludeFeatures || [];
     if(excludeFeatures.indexOf('VIEW_DASHBOARD') > -1){
       const { roleFeatures } = res;
       const featureExists = (module, feature) => roleFeatures.some(item => item.module === module && item.features.includes(feature));
       if (featureExists("CLOUD_POS", "PAYMENTS")) {
         window.open("/virtual-terminal/list", "_self");
       } else if (featureExists("TRANSACTION", "VIEW_TRANSACTION")) {
         window.open("/transaction-management/transactions", "_self");
       } else {
         window.open("/user-management/users", "_self");
       }
    }else{
      window.open("/dashboardv2", "_self");
    }
  }


  onBack(event){
    this.activeModal.close();
  }

}
